import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as ArrowDown } from 'src/Images/icons/common/arrowdown.svg';
import { ReactComponent as GRNList } from 'src/Images/icons/sidebar/GRNList.svg';
import getColorCode from 'src/utils/GetThemeColor';
import 'src/style/createVehicleTracking.css';

const getFirstLineItem = (deliveryObj) => deliveryObj?.line_items?.[0] || {};

function LoadReviewListTab({ loadLineItem = [] }) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [expandedLoadId, setExpandedLoadId] = useState('');

  const handleToggleLoad = (loadId) => {
    setExpandedLoadId((currentLoadId) =>
      currentLoadId === loadId ? '' : loadId,
    );
  };

  const renderLoadDeliveryCard = (deliveryObj) => {
    const deliveryKey = deliveryObj?.delivery_unique_number;
    const lineItem = getFirstLineItem(deliveryObj);
    const product = lineItem?.product || {};

    return (
      <div className="create-load-delivery-card" key={deliveryKey}>
        <div className="div-flex-row div-space-between div-align-center">
          <span className="create-load-delivery-title text-bold">
            {deliveryObj?.sap_code || deliveryObj?.delivery_code || '-'}
          </span>
        </div>

        <div className="create-load-delivery-divider" />

        <div className="duplicate-vehicle-tracking-load-field-grid">
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Delivery Date</span>
            <span className="text-sm text-bold">
              {deliveryObj?.delivery_date ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Plant</span>
            <span className="text-sm text-bold">
              {lineItem?.plant?.name ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Product Description</span>
            <span className="text-sm text-bold">
              {lineItem?.product_description ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Product Name</span>
            <span className="text-sm text-bold">
              {product?.product_name ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Product SAP Code</span>
            <span className="text-sm text-bold">
              {product?.product_sap_code ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">SAP Code</span>
            <span className="text-sm text-bold">
              {deliveryObj?.sap_code ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Ship To Party</span>
            <span className="text-sm text-bold">
              {deliveryObj?.ship_to_party?.name ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Total Quantity</span>
            <span className="text-sm text-bold">
              {deliveryObj?.total_quantity ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Weight</span>
            <span className="text-sm text-bold">
              {deliveryObj?.weight ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Pack Quantity</span>
            <span className="text-sm text-bold">
              {deliveryObj?.pack_quantity ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Pack Type</span>
            <span className="text-sm text-bold">
              {deliveryObj?.pack_type ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Sales Order Number</span>
            <span className="text-sm text-bold">
              {deliveryObj?.sales_order_number ?? '-'}
            </span>
          </div>
          <div className="duplicate-load-field div-flex-column rg-5">
            <span className="text-grey text-sm">Grade</span>
            <span className="text-sm text-bold">
              {deliveryObj?.grade ?? '-'}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="duplicate-load-tab vertical-padding-10 horizontal-padding-10">
      <div className="div-flex-row div-space-between section-title div-align-center">
        <div className="text-xxl text-bold">Load List</div>
      </div>

      <div
        className={`div-flex-column vertical-padding-10 horizontal-padding-10 rg-10 theme-vertical-scrollable-container-${themeColor}  duplicate-vehicle-tracking-load-list-container`}
      >
        {loadLineItem.length > 0 ? (
          loadLineItem.map((loadObj) => {
            const isExpanded = expandedLoadId === loadObj.id;

            return (
              <div
                className={`duplicate-vehicle-tracking-load-row ${isExpanded ? 'is-open' : ''}`}
                key={loadObj.id}
              >
                <button
                  type="button"
                  className="duplicate-vehicle-tracking-load-row-header"
                  onClick={() => handleToggleLoad(loadObj.id)}
                >
                  <div className="div-flex-row div-align-center cg-10">
                    <GRNList className="duplicate-vehicle-tracking-load-icon" />
                    <span className="text-sm text-bold">{loadObj.title}</span>
                  </div>

                  <ArrowDown
                    className={`icon-size-sm ${
                      isExpanded ? 'rotate-icon-180' : ''
                    }`}
                    color={getColorCode(themeColor)}
                  />
                </button>

                {isExpanded && (
                  <div className="duplicate-vehicle-tracking-load-details div-flex-column rg-10">
                    {(loadObj.deliveries || []).map((deliveryObj) =>
                      renderLoadDeliveryCard(deliveryObj),
                    )}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="no-data-found-message border-bottom">
            <span className="text-sm">No Load Items Found</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoadReviewListTab;
